var _ = require('underscore');
var Base = require('front/components/Base/Base');

var template = require('./TopNavMobile.jinja');
require('./TopNavMobile.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .TopNavMobile-burger': 'toggleMenu',
        'click .TopNavMobile-searchButton': 'toggleSearch',
        'keydown .TopNavMobile-searchInput': 'onInputKeyDown'

    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onTopNavPopupShow', 'onTopNavPopupHide', 'onPagePopupShown', 'onPagePopupHidded', 'onScroll');

        this.previousScrollTop = 0;
        this.currentScrollDir = 1;
        this.continuousScrollDistance = 0;

        this.onScroll.__throttled = _.throttle(this.onScroll, 100, {trailing: true, leading: true}).bind(this);

        Base.prototype.initialize.call(this, options);

        this.viewsRegistration();
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

        app.views.topNavPopup.on('show', this.onTopNavPopupShow);
        app.views.topNavPopup.on('hide', this.onTopNavPopupHide);

        app.vent.on('PopupShown', this.onPagePopupShown);
        app.vent.on('PopupHidded', this.onPagePopupHidded);

        $(window).bind('scroll', this.onScroll.__throttled);

        this.onScroll();
    },


    destroy: function () {
        app.views.topNavPopup.off('show', this.onTopNavPopupShow);
        app.views.topNavPopup.off('hide', this.onTopNavPopupHide);

        app.vent.off('PopupShown', this.onPagePopupShown);
        app.vent.off('PopupHidded', this.onPagePopupHidded);

        $(window).unbind('scroll', this.onScroll.__throttled);

        return Base.prototype.destroy.call(this);
    },


    onScroll: function () {
        if (app.state.preventMenuShowOnScroll) {
            return;
        }

        var currentScrollTop = $(window).scrollTop();
        var currentScrollDir = currentScrollTop > this.previousScrollTop ? 1 : -1;
        var deltaScroll = Math.abs(currentScrollTop - this.previousScrollTop);

        if (this.currentScrollDir == currentScrollDir) {
            this.continuousScrollDistance += deltaScroll;
        } else {
            this.continuousScrollDistance = deltaScroll;
        }

        var threshold = currentScrollDir == 1 ? 0 : 100;
        var passThreshold = this.continuousScrollDistance >= threshold;

        if (passThreshold) {
            this.$el.toggleClass('TopNavMobile--outscreen', currentScrollDir == 1);
        }

        if (currentScrollTop <= 100) {
            this.$el.removeClass('TopNavMobile--outscreen');
        }

        if (this.$el.hasClass('TopNavMobile--outscreen')) {
            app.vent.trigger('nav-hidden');
        } else {
            app.vent.trigger('nav-visible');
        }

        this.previousScrollTop = currentScrollTop;
        this.currentScrollDir = currentScrollDir;
    },


    onPagePopupShown: function (params) {
        if (params.isBlack) {
            this.$el.addClass('TopNavMobile--pagePopupOpened');
        }
        this.hideSearch();
    },


    onPagePopupHidded: function () {
        this.$el.removeClass('TopNavMobile--pagePopupOpened');
    },


    onTopNavPopupShow: function () {
        this.$el.addClass('TopNavMobile--popupOpened');
        this.$el.removeClass('TopNavMobile--outscreen');
        this.hideSearch();
    },


    onTopNavPopupHide: function () {
        this.$el.removeClass('TopNavMobile--popupOpened');
    },


    toggleMenu: function () {
        if (app.views.topNavPopup.isShown()) {
            this.hideMenu();
        } else {
            this.showMenu();
        }
    },


    hideMenu: function () {
        app.views.topNavPopup.hide();
    },


    showMenu: function () {
        app.views.topNavPopup.show();
    },


    hideSearch: function () {
        this.$el.removeClass('TopNavMobile--searchOpened');
    },


    showSearch: function () {
        this.$el.addClass('TopNavMobile--searchOpened');
        this.hideMenu();
    },


    toggleSearch: function () {
        if (this.$el.hasClass('TopNavMobile--searchOpened')) {
            this.hideSearch();
        } else {
            this.showSearch();
        }
    },


    onInputKeyDown: function (e) {
        var $input = $(e.currentTarget);
        var query = $.trim($input.val());

        if (e.keyCode == 13 && query.length > 2) { //enter
            Backbone.history.navigate(app.composeSearchUrl(query, 1, 'all'), {trigger: 'true'});
            this.hideSearch();
        }

        if (e.keyCode == 27) { //esc
            this.hideSearch();
        }
    }

});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/TopNav/TopNavMobile.js
// module id = 244
// module chunks = 0